/**
 * Created by luka on 23.02.2018.
 */

import {
    DECLINE_PAYOUT_LOADING, DECLINE_PAYOUT_SUCCESS, LOADING_DECLINE_PAYOUT_FAILED, LOADING_RETRY_FAILED, RETRY_LOADING,
    RETRY_SUCCESS
} from "../actions/types";
export function loadingRetryFailed(state = false, action) {
    switch (action.type) {
        case LOADING_RETRY_FAILED:
            return action.error;
        default:
            return state;
    }
}
export function retryLoading(state = false, action) {
    switch (action.type) {
        case RETRY_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}

export function retrySuccess(state = {}, action) {
    switch (action.type) {
        case RETRY_SUCCESS:
            return action.retry;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/retry/RetryReducer.js